import { navigateTo, useRoute } from '#imports'
import type { RouteLocationNormalized } from 'vue-router'

import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { omit } from '@backmarket/utils/object/omit'

import { VALID_GRADES } from '~/scopes/product/constants'
import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'

/**
 * When the grade in the URL is not valid (i.e., #l=1), the page is broken. We should remove it to fallback on the default one instead.
 *
 * This can happen in various occasions:
 * - Wrong copy paste
 * - Errors during algolia indexation
 */
export async function useInvalidGradeFallback(
  route: RouteLocationNormalized = useRoute(),
) {
  const { grade } = useUrlParams(route)
  const logger = useLogger()

  if (!grade.value || VALID_GRADES.includes(grade.value)) {
    return undefined
  }

  logger.info('[PRODUCT] Invalid grade in the URL', {
    owners: ['bot-squad-product-page-front'],
  })

  const link = {
    ...route,
    type: 'internal',
    query: omit(route.query, ['l']),
    hash: route.hash,
    replace: true,
  }

  return navigateTo(link)
}
